import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Product } from '@/utils/productHelpers';
import { getSupabaseClient } from '@/utils/supabaseClient';
import { activateSparkConfirm } from '@/utils/sparkActivationApi';

const EmailAuthCallback: React.FC = () => {
  const history = useHistory();
  const { product } = useParams<{ product: Product }>();
  useEffect(() => {
    const handleCallback = async () => {
      try {
        const { data: { session } } = await getSupabaseClient().auth.getSession();

        if (!session) {
          history.replace(`/activate/${product}/email-auth`);
          return;
        }

        const supabaseUserId = session.user?.id ?? '';
        const patientUid = session.user?.user_metadata?.limbixUserId || '';

        // Flip entitlement to active — same as SmsVerify does after OTP verification.
        try {
          await activateSparkConfirm({ supabaseUserId, accessToken: session.access_token });
        } catch (err) {
          console.error('[EmailAuthCallback] activateSparkConfirm failed:', err);
        }

        history.replace(`/activate/${product}/user-info/confirmation`, {
          patientUid,
          flow: 'email',
        });
      } catch (err) {
        console.error('[EmailAuthCallback] Unexpected error:', err);
        history.replace(`/activate/${product}/email-auth`);
      }
    };

    handleCallback();
  }, [history, product]);

  return null;
};

export default EmailAuthCallback;
